var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiat = function SvgFiat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 28.5884V11.999H13.9363V13.9633H11.2998V19.1452H13.3033V21.0425H11.2998V28.5884H9ZM14.7598 28.626V12.0039H17.1513V28.626H14.7598ZM24.9902 11.999V14.0001L26.9096 13.9978V28.5849H29.1797V13.9978H31.0007V11.999H24.9902ZM20.5101 13.953V19.0776H22.9172C22.8649 18.721 22.821 18.404 22.7808 18.1136C22.5744 16.6214 22.4649 15.8303 21.793 13.953H20.5101ZM18.8913 28.6266H18.4199V11.999H23.3547C23.3921 12.1351 23.4636 12.286 23.5581 12.4854C24.1251 13.6821 25.5211 16.6283 25.3576 28.6266H24.1651H23.4846H23.136C23.1337 28.3134 23.1321 27.9482 23.1305 27.5474C23.1225 25.6083 23.111 22.8371 22.9901 21.1083H20.5101L20.4834 28.6266H19.7729H18.8913Z",
    fill: "currentColor"
  })));
};
export default SvgFiat;